import classNames from 'classnames';
import { FC, ReactElement } from 'react';

import { useExpandableTextBlockPresenter } from './ExpandableTextBlock.presenter';
import styles from './ExpandableTextBlock.styles.m.css';

interface IExpandableTextBlockProps {
  text: string;
  textMaxLength?: number;
  className?: string;
  showMoreText?: string;
  showMoreClassName?: string;
  renderTextFn?(text: string): string | ReactElement;
}

export const ExpandableTextBlock: FC<IExpandableTextBlockProps> = (props) => {
  const { text, className, textMaxLength, showMoreText, showMoreClassName, renderTextFn } = props;
  const presenter = useExpandableTextBlockPresenter({
    fullText: text,
    textMaxLength,
    showMoreText,
  });

  if (!text) {
    return null;
  }

  return (
    <div className={className}>
      <p className={styles.text}>{renderTextFn ? renderTextFn(presenter.text) : presenter.text}</p>
      {presenter.hasMore && (
        <span
          role="button"
          tabIndex={0}
          onClick={presenter.onShowMore}
          className={classNames(styles.showMore, showMoreClassName)}
        >
          {presenter.showMoreText}
        </span>
      )}
    </div>
  );
};
